<p *ngIf="vpsList.length > 0">{{basetos(user.email)}}</p>
<br>
<div class="row">
  <!-- column -->
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Vps Attivi</h4>
        <mat-divider  ></mat-divider>
      </div>
      <div style="padding: 20px">

        <div style="text-align: right;margin-bottom: 20px" *ngIf="vpsList.length>0">
          <button [disabled]="vpsChanges || errorVpsConto" (click)="saveVpsChanges()"
            style="max-width: 200px"
            class="btn btn-block btn-md btn-outline-danger">
            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" *ngIf="updating"></span>{{'user-manager.card-2.button-save'|translate}}</button>
        </div>
        <div *ngIf="vpsList.length == 0 && false" style="margin-top: 20px">
          <p style="margin-top: 20px; margin-left: 20px">
            {{'user-manager.card-2.empty-description'|translate}}
          </p>
        </div>
        <div *ngIf="vpsList.length == 0 && true">
          <p>
            {{'user-manager.card-2.description'|translate}}
          </p>
          <button mat-stroked-button (click)="attivaVpsGratuito()">
            {{'user-manager.card-2.button-action-activate'|translate}}
          </button>
        </div>
        <div *ngIf="vpsList.length > 0" style="margin-top: 20px">
          <div style="margin-top: 10px">
            <div *ngIf="!vpsList[0].running" [style.height.px]="(layoutManager.innerWidth<= 555) ? 75 : 40"
                 style="background: #fcd76f; height: 40px;padding: 10px;border-radius: 5px;">
              <table>
                <tr>
                  <td>
                    <mat-icon style="font-size: 25px; margin-top: -5px">warning</mat-icon>
                  </td>
                  <td>
                    <p style="margin-left: 10px">
                      Attendi l'attivazione del vps, una volta attivo riceverai una mail
                    </p>
                  </td>
                </tr>
              </table>
            </div><br>
            <p style="margin-bottom: 20px; margin-top: 10px">
              {{'user-manager.card-2.description-2'|translate}}
            </p>
            <mat-form-field style="margin-right: 10px">
              <input #boxId matInput placeholder="{{
            'user-manager.card-1.id-conto-placeholder'|translate
          }}" [value]="vpsList[0].id_conto"
                     (input)="updateIdContoVps(boxId, vpsList[0])">
            </mat-form-field>
            <mat-form-field style="margin-right: 10px">
              <input #boxPass matInput type="password" (input)="vpsList[0].password_conto=boxPass.value; vpsChanges=false;"
                     placeholder="{{'user-manager.card-2.password-placeholder'|translate}}"
                     [value]="vpsList[0].password_conto">
            </mat-form-field>
            <mat-form-field style="margin-right: 10px">
              <input #boxBrok matInput placeholder="{{'user-manager.card-2.server-placeholder'|translate}}"
                     (input)="vpsList[0].broker_server=boxBrok.value; vpsChanges=false;"
                     [value]="vpsList[0].broker_server">
            </mat-form-field>
          </div>

          <div *ngIf="vpsList[0].running" [style.height.px]="(layoutManager.innerWidth<= 555) ? 75 : 40">
            <mat-divider [inset]="true" style="width: 100%;margin: auto;"></mat-divider><br>
            Stato di attivazione del VPS:&ensp;&ensp;<span matTooltip="Informazioni VPS"
                                               class="label {{vpsActivationStateColor}} label-rounded">
              {{vpsActivationState}}</span>
          </div><br>

          <!-- Aggiunta softwares -->
          <mat-divider [inset]="true" style="width: 100%;margin: auto;"></mat-divider>
          <div style="margin-top: 20px;">
            <p style="margin-bottom: 10px">
              {{'user-manager.card-2.description-3'|translate}}
            </p>
            <div class="custom-control custom-checkbox mr-sm-2" *ngFor="let option of softwareOptions">
              <input type="checkbox" class="custom-control-input" id="customControlAutosizing{{option.key}}" *ngIf="!option.value"
                     (click)="(!option.value) ? addSoftwareToVps(option.key, vpsList[0]) :
                             removeSoftwareToVps(option.key, vpsList[0])">
              <input type="checkbox" class="custom-control-input" id="customControlAutosizing{{option.key}}" *ngIf="option.value"
                     (click)="(!option.value) ? addSoftwareToVps(option.key, vpsList[0]) :
                             removeSoftwareToVps(option.key, vpsList[0])" checked>
              <label class="custom-control-label" for="customControlAutosizing{{option.key}}">
                {{option.key}}
              </label>
            </div>
          </div>

          <br><br><br>
          <mat-divider [inset]="true" style="width: 100%;margin: auto;"></mat-divider>
          <div style="margin-top: 20px;">
            <p style="margin-bottom: 10px">
              Attiva nuovi Software
            </p>

            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th class="border-top-0">SOFTWARE</th>
                  <th class="border-top-0">Descrizione</th>
                  <th class="border-top-0" *ngIf="!layoutManager.smallMode">PREZZO</th>
                  <th class="border-top-0">Azione</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let soft of getFreeSoftwares()">
                  <td class="txt-oflo">{{soft.software_name.toUpperCase()}}</td>
                  <td class="txt-oflo">{{basetos(soft.short_description)}}</td>
                  <td class="txt-oflo" *ngIf="!layoutManager.smallMode">{{soft.price}} EUR</td>
                  <td><a routerLink="/admin/store" class="btn btn-block btn-outline-secondary" style="max-width: 200px">Aggiungi</a></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
